import { combineReducers } from 'redux'

import { automacaoReducer } from './automacaoReducer'
import { buscaArquivoReducer } from './buscaArquivoReducer'
import { cadastrosReducer } from './cadastros'
import { faturasReducer } from './faturasReducer'
import { filtrosReducer } from './filtrosReducer'
import { financeiroReducer } from './financeiroReducer'
import { manejadorReducer } from './manejadorReducer'
import { mensagensReducer } from './mensagensReducer'
import { menuUsuarios } from './menuUsuarios'
import { migracaoPlanoReducer } from './migracaoPlanoReducer'
import { notificacoesReducer } from './notificacoesReducer'
import { pedidosReducer } from './pedidosReducer'
import { breadCrumbs, permissao } from './permissaoReducer'
import { relatorioReducer } from './relatorioReducer'
import { smsReducer } from './smsReducer'
import { SystemControl } from './systemControl'
import { virtueyesReducer } from './virtueyesReducer'

export const Reducers = combineReducers({
  manejadorState: manejadorReducer,
  filtrosState: filtrosReducer,
  buscaArquivoState: buscaArquivoReducer,
  virtueyesState: virtueyesReducer,
  smsState: smsReducer,
  pedidosState: pedidosReducer,
  financeiroState: financeiroReducer,
  automacaoState: automacaoReducer,
  mensagensState: mensagensReducer,
  menuUsuarioState: menuUsuarios,
  notificacoesState: notificacoesReducer,
  breadCrumbsState: breadCrumbs,
  permissaoState: permissao,
  faturasState: faturasReducer,
  relatorioState: relatorioReducer,
  cadastrosState: cadastrosReducer,
  systemControlStates: SystemControl,
  migracaoPlanoState: migracaoPlanoReducer
})
